var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoiceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 65,
    viewBox: "0 0 57 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 4C0.5 1.79086 2.29086 0 4.5 0H39.25L56.5 17.5V61C56.5 63.2091 54.7091 65 52.5 65H4.5C2.29086 65 0.5 63.2091 0.5 61V4Z",
    fill: "#69787F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2729 17.4723L56.4688 17.5L39.2812 0.0312485L39.2813 13.4723C39.2813 15.6782 41.067 17.4677 43.2729 17.4723Z",
    fill: "#343F46"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2393 38.5781L42.2539 28.4531H45.1895L40.7334 41.25H38.7998L39.2393 38.5781ZM36.4619 28.4531L39.4678 38.5781L39.9248 41.25H37.9736L33.5439 28.4531H36.4619Z",
    fill: "#E2E8EE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3311 28.4531V41.25H27.6943L22.5527 32.6719V41.25H19.916V28.4531H22.5527L27.7031 37.04V28.4531H30.3311Z",
    fill: "#E2E8EE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4463 28.4531V41.25H12.8184V28.4531H15.4463Z",
    fill: "#E2E8EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceIcon);
export default __webpack_public_path__ + "static/media/invoice_icon.db1e8fa6680d4dec67d125d02054bded.svg";
export { ForwardRef as ReactComponent };